import {
  PUBLIC_URL,
  REACT_APP_MERCADO_PUBLICO_BASE_URL
} from '../../config/settings/environment.config'
import { Logo, LogoLink, Root } from './Header.styles'

/**
 * The Header container.
 */
const Header = () => {
  return (
    <Root>
      <LogoLink
        href={`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`}
        target="_top"
      >
        <Logo alt="Chilecompra" src={`${PUBLIC_URL}/assets/images/logo-mercadopublico.svg`} />
      </LogoLink>
    </Root>
  )
}

export default Header
